
// import script pricing from sweet people
require('../../../thesweetpeople/src/js/pricing.js');
